var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 225,
    viewBox: "0 0 255 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_94017)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 231.464,
    y: 35.25,
    width: 27,
    height: 120,
    rx: 13.5,
    transform: "rotate(25 231.464 35.25)",
    fill: "#F0B3AA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 62.7861,
    y: 93,
    width: 27,
    height: 90,
    rx: 13.5,
    transform: "rotate(25 62.7861 93)",
    fill: "#F0B3AA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 93.8657,
    width: 27,
    height: 48.1906,
    rx: 13.5,
    transform: "rotate(25 93.8657 0)",
    fill: "#F0B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.312 58.1516C124.372 55.2001 130.628 55.2001 135.688 58.1516L177.938 82.7974C182.93 85.7096 186 91.0542 186 96.8338V143.167C186 148.946 182.93 154.291 177.938 157.203L135.688 181.849C130.628 184.8 124.372 184.8 119.312 181.849L77.0621 157.203C72.0698 154.291 69 148.946 69 143.167V96.8338C69 91.0542 72.0698 85.7096 77.0621 82.7974L119.312 58.1516Z",
    fill: "#C24632"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121 123.25L121 95.6255C121 92.0356 123.91 89.1255 127.5 89.1255C131.09 89.1255 134 92.0356 134 95.6255L134 123.25C134 126.84 131.09 129.75 127.5 129.75C123.91 129.75 121 126.84 121 123.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.625 146C135.625 150.488 131.987 154.125 127.5 154.125C123.013 154.125 119.375 150.488 119.375 146C119.375 141.513 123.013 137.875 127.5 137.875C131.987 137.875 135.625 141.513 135.625 146Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_94017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNegative);
export default __webpack_public_path__ + "static/media/empty-state-negative.e7d87a4810115288a2b7ac38ada306ca.svg";
export { ForwardRef as ReactComponent };